import React, { createContext, useContext, useState, ReactNode ,useMemo} from 'react';

// Create a context
const TabContext = createContext<any>(null);

interface TabProviderProps {
  children: ReactNode;
}

// Create a provider for the context
export const TabProvider = ({ children }: TabProviderProps) => {
  const types = [
    'banner',
    'whyUs',
    'features',
    'tools',
    'experience',
    'faq',
    'useCase',
    'clients',
    'elevateLearning',
    'getInTouch',
    'featureCards',
    'testimonials'
  ];
  const [tabValue, setTabValue] = useState(0);
  const handleTabChange = (newValue: any) => {
    if (typeof newValue === 'number') {
      setTabValue(newValue);
    } else if (typeof newValue === 'string') {
      const index = types.indexOf(newValue);

      if (index !== -1) {
        setTabValue(index);
      }
    } else {
      console.error('Unsupported type for tab value:', newValue);
    }
  };

  const value = useMemo(
    () => ({ tabValue, handleTabChange }),
    [tabValue] // only depends on tabValue (handleTabChange is stable)
  );

  return <TabContext.Provider value={value}>{children}</TabContext.Provider>;
};

// Create a custom hook to use the TabContext
export const useTabContext = () => {
  return useContext(TabContext);
};
